import { render, staticRenderFns } from "./crowdDetails.vue?vue&type=template&id=a9c60d7c&scoped=true&"
import script from "./crowdDetails.vue?vue&type=script&lang=js&"
export * from "./crowdDetails.vue?vue&type=script&lang=js&"
import style0 from "./crowdDetails.vue?vue&type=style&index=0&id=a9c60d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c60d7c",
  null
  
)

export default component.exports